export default "__VITE_ASSET__Lb13N939__"